<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'checkin' ? 'active' : ''" @click.prevent="abrir('checkin')">
                        Check-In
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'escalas' ? 'active' : ''" @click.prevent="abrir('escalas')">
                        Escalas
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'alocacao' ? 'active' : ''" @click.prevent="abrir('alocacao')">
                        Alocação
                    </a>
                </li>
                <li class="nav-item">
                    <div class="btn-group dropleft">
                        <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <a class="dropdown-item" href="#" :class="aba == 'tipos' ? 'active' : ''" @click.prevent="abrir('tipos')">
                                Tipos 
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'abrir' ? 'active' : ''" @click.prevent="abrir('abrir')">
                                Abrir 
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <tipo-de-escala v-if="aba == 'tipos'" />
        <escala-agenda v-if="aba == 'escalas'" />
        <escala-alocacao v-if="aba == 'alocacao'" />
        <escala-abrir v-if="aba == 'abrir'" />
        <escala-check-in v-if="aba == 'checkin'" />
        
    </div>
</template>

<script>
import TipoDeEscala from './TipoDeEscala.vue';
import EscalaAgenda from './EscalaAgenda.vue';
import EscalaAlocacao from './EscalaAlocacao.vue';
import EscalaAbrir from './EscalaAbrir.vue';
import EscalaCheckIn from './EscalaCheckIn.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null, 
        };
    },

    props: ['aba'],

    components: { 
        TipoDeEscala,
        EscalaAgenda, 
        EscalaAlocacao, 
        EscalaAbrir, 
        EscalaCheckIn, 
    },

    methods: { 
        abrir(aba) { 
            if ( aba != this.aba ) { 
                this.$router.push({ path: '/escalas/' + aba });
            }
        },
    }
}
</script>